export interface FacilityAttendanceSettingsDto {
  id: number;
  facilityId: string;
  clockInWindowBeforeShiftMinutes: number;
  clockInWindowAfterShiftMinutes: number;
  clockOutWindowBeforeShiftMinutes: number;
  clockOutWindowAfterShiftMinutes: number;
  mobileClockInEnabled: boolean;
  computerClockInEnabled: boolean;
  authorizedClockInRequired: boolean;
  requireContractorSignatureAtClockIn: boolean;
  notifyManagersAfterMinutes: number;
  notifyContractorsAfterMinutes: number;
  managerMissedClockNotifications: boolean;
  contractorMissedClockNotifications: boolean;
}

export interface UpdateFacilityAttendanceSettingsDto {
  clockInWindowBeforeShiftMinutes?: number;
  clockInWindowAfterShiftMinutes?: number;
  clockOutWindowBeforeShiftMinutes?: number;
  clockOutWindowAfterShiftMinutes?: number;
  mobileClockInEnabled?: boolean;
  computerClockInEnabled?: boolean;
  authorizedClockInRequired?: boolean;
  requireContractorSignatureAtClockIn?: boolean;
  notifyManagersAfterMinutes?: number;
  notifyContractorsAfterMinutes?: number;
  managerMissedClockNotifications?: boolean;
  contractorMissedClockNotifications?: boolean;
}
